// import './App.css';
// import AddFamily from './AddFamily';
// import FamjamVibeSlider from './FamjamVibeSlider';
// import FamilyNameInput from './FamilyName';
// import FirstPage from './FirstPage';
// import LoginPage from './SignupPage';
// import SettingsPage from './SettingsPage';
// import SubscriptionCard from './SubscriptionCard';
// import SubscriptionManager from './SubscriptionManager';
// import TodayAttendance from './TodayAttendance';
// import DailyJamComponent from './DailyJamPage';
// import AllSet from './AllSet';
// import HomePage from './HomePage';
// import SignupPage from './SignupPage';
// import SigninPage from './SigninPage';
// import DailyJamPage from './DailyJamPage';
// import { FaThinkPeaks } from 'react-icons/fa';
// import ThankYouPage from './ThankYouPage';
// import AccountDeleted from './AccountDeleted';
// import HomePlayerSelect from './HomePlayerSelect';
// import HubPage from './HubPage';
// import ResetPassword from './ResetPassword';
// import ChangePassword from './ChangePassword';
// import Values from './Values';

// function App() {
//   return (
//   // <FirstPage />
//   //  <SigninPage />
//   //  <ResetPassword />
//   //  <ChangePassword />
//   // <Values />
//   //  <SignupPage />
//   //  <DailyJamPage />
//   // <FamilyNameInput />
//   // <AddFamily />
//   // <FamjamVibeSlider />
//   // <AllSet />
//   // <HomePage />
//   // <HomePlayerSelect />
//   //  <SubscriptionCard />
//   // <HubPage />
//   <SettingsPage />
//   // <AccountDeleted />
//   // <ThankYouPage />
//   );
// }

// export default App;



import React, { useState } from 'react';
import FirstPage from './FirstPage';
import SigninPage from './SigninPage';
import SignupPage from './SignupPage';
import DailyJamComponent from './DailyJamPage';
import AddFamily from './AddFamily';
import AllSet from './AllSet';
import FamjamVibeSlider from './FamjamVibeSlider';
import HomePlayerSelect from './HomePlayerSelect';
import SubscriptionCard from './SubscriptionCard';
import HubPage from './HubPage';
import Values from './Values';
import HomePage from './HomePage';
import FamilyName from './FamilyName';

const App = () => {
  const [currentPage, setCurrentPage] = useState('first');
  const [userData, setUserData] = useState(null);

  const navigateToSignin = () => {
    setCurrentPage('signin');
  };

  const navigateToSignup = () => {
    setCurrentPage('signup');
  };

  const navigateToOnboarding = (userInfo) => {
    setUserData(userInfo);
    setCurrentPage('onboarding');
  };

  const navigateToDailyJam = () => {
    setCurrentPage('dailyjam');
  };

  const navigateToFamilyInput = () => {
    setCurrentPage('familyInput');
  };

  const handleFamilyNameSave = (allSet) => {
    setUserData(prev => ({
      ...prev,
      allSet: allSet
    }));
    setCurrentPage('AddFamily');
  };

  const handleFamilProfiles = (profiles) => {
    setUserData(prev => ({
      ...prev,
      profiles: profiles
    }));
    setCurrentPage('FamjamVibeSlider');
  };


  const handleFamjamslides = (famjamSlides) => {
    setUserData(prev => ({
      ...prev,
      famjamSlides: famjamSlides
    }));

    setCurrentPage('AllSet');
  };

  const handleAllSet = (HomePage) => {
    setUserData(prev => ({
      ...prev,
      HomePage: HomePage
    }));
    setCurrentPage('HomePage');
  };

  const handleUserSelction = (HomePage) => {
    setUserData(prev => ({
      ...prev,
      HomePage: HomePage
    }));

    setCurrentPage('SubscriptionCard');
  };

  const handleHomePlayerSelectContinue = (HomePage) => {
    setUserData(prev => ({
      ...prev,
      HomePage: HomePage
    }));

    setCurrentPage('HubPage');
  };

  const handleHomePlayerSelect = (HomePlayerSelect) => {
    setUserData(prev => ({
      ...prev,
      HomePlayerSelect: HomePlayerSelect
    }));

    setCurrentPage('HomePlayerSelect');
  };

  const handleSignupSuccess = (userInfo) => {
    setUserData(userInfo);
    setCurrentPage('signin');
  };

  const renderPage = () => {
    switch (currentPage) {
      case 'first':
        return <FirstPage onContinue={navigateToSignup} />;
      case 'signup':
        return (
          <SignupPage
            onSignupSuccess={handleSignupSuccess}
            onLoginClick={navigateToSignin}
          />
        );
      case 'signin':
        return (
          <SigninPage
            onSigninSuccess={navigateToOnboarding}
            onSignupClick={navigateToSignup}
          />
        );
      case 'onboarding':
        return <Values userData={userData} onComplete={navigateToDailyJam} onBack={() => setCurrentPage('signin')} />;
        case 'dailyjam':
        return <DailyJamComponent userData={userData} onComplete={navigateToFamilyInput} onBack={() => setCurrentPage('onboarding')} />;
        case 'familyInput':
          return (
            <FamilyName
              userData={userData}
              onBack={() => setCurrentPage('dailyjam')}
              onSave={handleFamilyNameSave}
            />
          );
          case 'AddFamily':
          return (
            <AddFamily
              userData={userData}
              onBack={() => setCurrentPage('familyInput')}
              onComplete={handleFamilProfiles}
            />
          );
          case 'FamjamVibeSlider':
          return (
            <FamjamVibeSlider
              userData={userData}
              onBack={() => setCurrentPage('AddFamily')}
              onComplete={handleFamjamslides}
            />
          );
          case 'AllSet':
          return (
            <AllSet
              userData={userData}
              onBack={() => setCurrentPage('FamjamVibeSlider')}
              onComplete={handleAllSet}
            />
          );
          case 'HomePage':
          return (
            <HomePage
              userData={userData}
              onComplete={handleHomePlayerSelect}
              onBack={() => setCurrentPage('AllSet')}
            />
          );
          case 'HomePlayerSelect':
          return (
            <HomePlayerSelect
              userData={userData}
              onBack={() => setCurrentPage('HomePage')}
              onComplete={handleUserSelction}
              onContinue={handleHomePlayerSelectContinue}
            />
          );
          case 'HubPage':
            return (
              <HubPage
                userData={userData}
                onBack={() => setCurrentPage('HitFamJam')}
                onComplete={handleUserSelction}
              />
            );
          case 'SubscriptionCard':
            return (
              <SubscriptionCard
                userData={userData}
                onBack={() => setCurrentPage('HomePlayerSelect')}
                onSave={handleAllSet}
              />
            );
      default:
        return <FirstPage onContinue={navigateToSignup} />;
    }
  };

  return <>{renderPage()}</>;
};

export default App;